import { createContext, useContext, useEffect, useState } from "react";
import { useConfig } from "./ConfigProvider";
import { GetParameter, IsWorkingDay, GetLicense } from "../Services/ParameterService";
import { useMediaQuery } from "react-responsive";
import { Licenses } from "../Data/Licenses.ts";

const ParamContext = createContext()

export const useParams = () => {
    return useContext(ParamContext)
}

export const ParamsProvider = ({ children }) => {
    const { api } = useConfig()
    const isMobile = useMediaQuery({ maxWidth: 1400 })
    const [availabilityCutoffTime, setAvailabilityCutoffTime] = useState('15:00')//Godzina graniczna dla dostępności (hh:mm)

    const [indexMask, setIndexMask] = useState(() => { //Maska dla indexu
        return localStorage.getItem('indexMask') || null
    })
    const [priceListExportMaxArticle, setPriceListExportMaxArticle] = useState(() => {
        return localStorage.getItem('priceListExportMaxArticle') || 0
    })

    const [geolocationApiKey, setGeolocationApiKey] = useState('') //Klucz do API google
    const [searchingQueryDelay, setSearchingQueryDelay] = useState(500) //Opóznienie w wyszukiwaniu produktów (w milisekundach)
    const [searchingQueryCharNumber, setSearchingQueryCharNumber] = useState(1) //Ilość znaków, po których następuje szukanie produktów
    const [eInvoiceEmail0101, setEInvoiceEmail0101] = useState('') //email do zgłośeń efaktur dla oddziału 0101
    const [eInvoiceEmail0201, setEInvoiceEmail0201] = useState('')//email do zgłośeń efaktur dla oddziału 0201
    const [license, setLicense] = useState(localStorage.getItem('APP_LICENSE') || '')// licencja programu
    const [autoLogOutTime, setAutoLogoutTime] = useState(5) //czas do automatycznego wylogowania podawany w minutach
    const [basketItemsCountLimit, setBasketItemsCountLimit] = useState(200) //Limit ilości pozycji w koszyku

    useEffect(() => {
        handleGetAutoLogoutTime()

        const storedIndexMask = localStorage.getItem('indexMask')
        if (!storedIndexMask) {
            handleGetIndexMask()
        }
        const storedPriceListExportMaxArticle = localStorage.getItem('priceListExportMaxArticle')
        if (!storedPriceListExportMaxArticle) {
            handleGetPriceListExportMaxArticle()
        }
        handleGetBasketItemsCountLimit()
        handleGetGeolocationKey()
        handleGetAvailabilityCutoffTime()
        handleGetSearchingQueryDelay()
        handleGetSearchingQueryCharNumber()
        handleGetEInvoiceEmails()
    }, [api])

    useEffect(() => {
        handleGetLicense()
        updateIconsAndTitles()
    }, [license])

    const updateIconsAndTitles = () => {
        const updateIcon = () => {
            const favicon = document.querySelector("link[rel='icon']");
            const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
            const darkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

            if (favicon) {
                switch (license) {
                    case Licenses.Ferrodo:
                        favicon.href = darkMode ? "/ferrodo-dark.ico" : "/ferrodo-light.ico";
                        break;
                    case Licenses.Hydraulik:
                        favicon.href = darkMode ? "/ferrodo-dark.ico" : "/ferrodo-light.ico";
                        break;
                }
            }

            if (appleTouchIcon) {
                switch (license) {
                    case Licenses.Ferrodo:
                        appleTouchIcon.href = darkMode ? "/ferrodo-dark.ico" : "/ferrodo-light.ico";
                        break;
                    case Licenses.Hydraulik:
                        appleTouchIcon.href = darkMode ? "/ferrodo-dark.ico" : "/ferrodo-light.ico";
                        break;
                }
            }
        };
        // Ustaw favicon na początku
        updateIcon();

        const updateTitle = () => {

            switch (license) {
                case Licenses.TgInstalacje:
                    document.title = "TG Instalacje";
                    break;
                case Licenses.Ferrodo:
                    document.title = "E-Handel FC";
                    break;
                case Licenses.Hydraulik:
                    document.title = "E-Handel Hydraulik";
                    break;
                case Licenses.Carmen:
                    document.title = "E-Handel Carmen";
                    break;
                default:
                    document.title = "E-Handel";
                    break;
            }

        }

        updateTitle()

        // Nasłuchuj zmiany trybu kolorów
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        mediaQuery.addEventListener("change", updateIcon);

        // Czyszczenie po zakończeniu komponentu
        return () => {
            mediaQuery.removeEventListener("change", updateIcon);
        };
    }

    const handleGetIndexMask = async () => {
        const res = await GetParameter(api, 'IndexMask', 'char', false)
        if (res.data) {
            setIndexMask(res.data)
            localStorage.setItem('indexMask', res.data)
        }
    }
    const handleGetPriceListExportMaxArticle = () => {
        GetParameter(api, 'PriceListExportMaxArticle', 'num', false).then(res => {
            setPriceListExportMaxArticle(res.data)
            localStorage.setItem('priceListExportMaxArticle', res.data)
        })
            .catch(e => {
                console.log(e)
            })
    }
    const handleCheckIsWorkingDay = async (date) => {
        try {
            const res = await IsWorkingDay(api, date)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const handleGetBasketItemsCountLimit = () => {
        GetParameter(api, 'BasketItemsCountLimit', 'num', false).then(res => {
            setBasketItemsCountLimit(res.data)
        }).catch(e => {
            console.log(e)
        })
    }

    const handleGetGeolocationKey = () => {
        GetParameter(api, 'GeolocationApiKey', 'char', true).then(res => {
            setGeolocationApiKey(res.data)
        }).catch(e => {
            console.log(e)
        })
    }
    const handleGetAvailabilityCutoffTime = () => {
        GetParameter(api, 'AvailabilityCutoffTime', 'char', false).then(res => {
            setAvailabilityCutoffTime(res.data)
        }).catch(e => {
            console.log(e)
            setAvailabilityCutoffTime(null)
        })
    }
    const handleGetSearchingQueryDelay = () => {
        GetParameter(api, 'SearchingQueryDelay', 'num').then(res => {
            setSearchingQueryDelay(res.data)
        }).catch(e => {
            console.log(e)
            setSearchingQueryDelay(500)
        })
    }
    const handleGetSearchingQueryCharNumber = () => {
        GetParameter(api, 'SearchingQueryCharNumber', 'num').then(res => {
            setSearchingQueryCharNumber(res.data)
        }).catch(e => {
            console.log(e)
            setSearchingQueryCharNumber(1)
        })
    }
    const handleGetEInvoiceEmails = () => {
        GetParameter(api, '0101eInvoiceEmail', 'char', false).then(res => {
            setEInvoiceEmail0101(res.data)
        }).catch(e => {
            console.log(e)
        })
        GetParameter(api, '0201eInvoiceEmail', 'char', false).then(res => {
            setEInvoiceEmail0201(res.data)
        }).catch(e => {
            console.log(e)
        })
    }

    const handleGetLicense = async () => {
        try {
            const res = await GetLicense(api)
            setLicense(res.data)
            localStorage.setItem('APP_LICENSE', res.data)
        }
        catch (error) {
            console.log(error)
            setLicense('')
            localStorage.setItem('APP_LICENSE', '')
        }
    }

    const handleGetAutoLogoutTime = () => {
        GetParameter(api, 'AutoLogOutTime', 'num', false).then(res => {
            setAutoLogoutTime(res.data)
        }).catch(e => {
            console.log(e)
            setAutoLogoutTime(20)
        })
    }

    return <ParamContext.Provider value={{
        indexMask,
        priceListExportMaxArticle,
        geolocationApiKey,
        availabilityCutoffTime,
        searchingQueryDelay,
        searchingQueryCharNumber,
        eInvoiceEmail0101,
        eInvoiceEmail0201,
        license,
        isMobile,
        autoLogOutTime,
        basketItemsCountLimit,
        handleCheckIsWorkingDay,
        handleGetLicense
    }} >
        {children}
    </ParamContext.Provider>
}
